import './Card.scss';
import { forAll } from '@stst/Javascript/util';

/**
 * @param {HTMLElement} card
 * @param {function(HTMLElement): HTMLAnchorElement} getLink
 * @param {function(HTMLElement): void=} cb
 * @returns {boolean}
 */
export const linkCard = (card, getLink = card => card.querySelector('a'), cb) => {
    if (document.body.classList.contains('neos-backend')) {
        return false;  // do nothing
    }
    card.style.cursor = 'pointer';
    let down, up, link = getLink(card);
    if (link === null) {
        return false;
    }
    card.onmousedown = () => down = +new Date();
    card.onmouseup = (e) => {
        if (e.which !== 1)
            return false;
        up = +new Date();
        if (up - down < 200) {
            link.click();
        }
    };
    if (cb && typeof cb === 'function') {
        cb(card);
    }
    return true;
};

forAll('.js-card', card => {
    linkCard(
        (/** @type {HTMLDivElement} */(card)),
        card => card.querySelector('.card__link'),
        card => card.classList.add('card--link')
    );
});
